import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import styled from "styled-components";
import { AGI_GRID_COLUMNS } from "./agiList.styled";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const AbsenceRowGrid = styled.div<{ $isLastRow: boolean }>`
  display: grid;
  grid-template-columns: ${AGI_GRID_COLUMNS};
  column-gap: ${Spacing.sm}px;
  padding-bottom: ${(props) => (props.$isLastRow ? "0" : `${Spacing.md}px`)};
  border-bottom: ${(props) =>
    props.$isLastRow ? "none" : `1px solid ${ColorV2.Blue6}`};
`;
